export type DepartureCalculatedPrice = {
  success: boolean;
  final_price?: number;
  price_per_person?: number | null;
  original_price_per_person?: number | null;
  discount_amount?: number;
  applied_campaigns?: Array<{ name?: string; discount_percentage?: number }>;
};

export type ResolvedDeparturePrice = {
  perPerson: number;
  originalPerPerson: number;
  finalTotal: number | null;
  hasDiscount: boolean;
  discountPercentage: number | null;
};

/** Çıkış indirimi + API fiyatı: tek kaynak, kişi başına en düşük geçerli fiyat. */
export function resolveGroupDeparturePrice(
  calculated: DepartureCalculatedPrice | null | undefined,
  basePerPerson: number | null,
  departureDiscountPct: number | null | undefined,
  guestCount: number,
): ResolvedDeparturePrice | null {
  const pct = departureDiscountPct != null && !Number.isNaN(Number(departureDiscountPct))
    ? Math.max(0, Number(departureDiscountPct))
    : 0;

  const fromApi =
    calculated?.success && calculated.price_per_person != null
      ? Number(calculated.price_per_person)
      : null;
  const origFromApi =
    calculated?.success && calculated.original_price_per_person != null
      ? Number(calculated.original_price_per_person)
      : null;

  const originalPerPerson = origFromApi ?? basePerPerson ?? fromApi;
  if (originalPerPerson == null || Number.isNaN(originalPerPerson)) {
    return null;
  }

  let perPerson = fromApi ?? originalPerPerson;
  if (pct > 0) {
    perPerson = Math.min(perPerson, originalPerPerson * (1 - pct / 100));
  }

  const hasDiscount = perPerson < originalPerPerson - 0.001;
  const discountPercentage = hasDiscount
    ? pct > 0
      ? pct
      : Math.round((1 - perPerson / originalPerPerson) * 100)
    : null;

  let finalTotal: number | null = null;
  const apiFinal =
    calculated?.success && calculated.final_price != null ? Number(calculated.final_price) : null;
  const expectedFromPerPerson =
    guestCount > 0 ? Math.round(perPerson * guestCount * 100) / 100 : null;
  if (
    apiFinal != null &&
    !Number.isNaN(apiFinal) &&
    fromApi != null &&
    Math.abs(fromApi - perPerson) < 0.02 &&
    Math.abs(apiFinal - (expectedFromPerPerson ?? apiFinal)) < 0.05
  ) {
    finalTotal = apiFinal;
  } else if (expectedFromPerPerson != null) {
    finalTotal = expectedFromPerPerson;
  }

  return {
    perPerson: Math.round(perPerson * 100) / 100,
    originalPerPerson: Math.round(originalPerPerson * 100) / 100,
    finalTotal,
    hasDiscount,
    discountPercentage,
  };
}
